import { NavLink } from "react-router-dom";

const links = [
  ["Discover", "/"],
  ["Reports", "/reports"],
  ["Archive", "/archive"],
  ["Methodology", "/methodology"],
  ["Pro", "/pro"],
] as const;

export function Header() {
  return (
    <header className="site-header">
      <div className="site-shell site-header-inner">
        <NavLink to="/" className="brand-lockup" aria-label="FTM home">
          <span className="brand-mark">F</span>
          <span className="brand-wordmark"><span>FIND THE MISPRICED</span><small>MARKET INTELLIGENCE</small></span>
        </NavLink>
        <nav className="desktop-primary-nav" aria-label="Primary navigation">
          {links.map(([label, path]) => (
            <NavLink
              key={path}
              to={path}
              end={path === "/"}
              className={({ isActive }) => `desktop-nav-link ${isActive ? "desktop-nav-link-active" : ""}`}
            >
              {label}
            </NavLink>
          ))}
        </nav>
        <NavLink className="header-pro-cta" to="/pro">Go Pro <span aria-hidden="true">↗</span></NavLink>
      </div>
    </header>
  );
}
